var TEndPoints = /*#__PURE__*/function (TEndPoints) {
  TEndPoints["V1"] = "v1";
  TEndPoints["V2"] = "v2";
  TEndPoints["V3"] = "v3";
  TEndPoints["V4"] = "v4";
  TEndPoints["V5"] = "v5";
  TEndPoints["V6"] = "v6";
  return TEndPoints;
}(TEndPoints || {});
export const prodFrontendUrl = 'https://geovelo.app';
export const companyContractPremiumCodes = ['geovelo-entreprise-standard', 'geovelo-entreprise-premium'];
export const companyContractCodes = [...companyContractPremiumCodes, 'geovelo-entreprise-free', 'geovelo-entreprise-holding'];
let environment = {
  frontendUrl: 'https://dev.geovelo.app',
  backendUrl: 'https://backend-dev.geovelo.fr',
  enterpriseUrl: 'https://app-dev.geovelo-entreprise.com/',
  enterpriseShowcaseUrl: 'https://geovelo-entreprise.com/',
  eventsSiteUrl: 'https://challenges-dev.geovelo.app/',
  tileServer: {
    url: 'https://tileserver-dev.geovelo.fr',
    styleDirs: {
      base: 'base-no-label-with-facilities-v2-5-vector',
      labels: 'labels-v2-vector',
      dark: 'base-dark-style-no-label-v2-5-vector',
      darkLabels: 'label-dark-style-v2-3-vector',
      facilities: 'facilities_v2-vector',
      facilitiesIDFM: 'facilities-style-idfm-vector',
      toner: 'app-toner-style-v2-3-with-geovelo-overlays-vector'
    }
  },
  defaultApiVersion: 2,
  apiVersions: {
    v1: 1,
    v3: 3,
    v4: 4,
    v5: 5,
    v6: 6
  },
  apiKey: '',
  source: '',
  mapillaryAccessToken: 'MLY|3620358691401240|8cc0f2ca4b24b2a9ab3d5cffdba027e9',
  lav: {
    backendUrl: 'https://loire-a-velo-search.apsulis.ninja',
    imagesUrl: 'https://loireavelo.fr',
    apiKey: 'Bearer 79d5040298cbea960280a02755f72cfe836f885a0583d431135f67fb95942f23'
  },
  bikeAllowanceUrl: 'https://indemnitevelo-dev.geovelo.fr',
  faqUrl: 'https://faq.geovelo.app',
  firebase: {
    apiKey: 'AIzaSyBhqyOfGFxeOi76Bw5SA3dJTaGFPTm5IBI'
  },
  osm: {
    apiUrl: 'https://master.apis.dev.openstreetmap.org'
  },
  android: {
    bundleId: 'fr.geovelo',
    storeUrls: {
      fr: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=FR',
      en: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=US',
      de: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=DE',
      es: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=ES'
    }
  },
  ios: {
    bundleId: 'fr.lcdm.geovelo',
    storeUrls: {
      fr: 'https://apps.apple.com/fr/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      en: 'https://apps.apple.com/us/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      de: 'https://apps.apple.com/de/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      es: 'https://apps.apple.com/es/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge'
    }
  },
  enableTmpFacilities: false,
  widgetDefaultApiKey: '1d4105cf-3fde-4373-829b-2804a95aafb1',
  savedKgOfCO2PerKilometer: 0.2176,
  enableSimplifyCrossingInstructions: true,
  strava: {
    clientId: '198473'
  },
  wahoo: {
    clientId: 'owPFUYx6SqmNctdTDxw3PBjl_LN3Z5PneeMlrtFb-ss'
  },
  freeOfferCustomChallengesMaxDaysCount: 7,
  freeOfferSubgroupsLeaderboardsMaxRowsCount: 0,
  freeOfferEmployeesLeaderboardsMaxRowsCount: 10,
  bttf: {
    communicationKitUrl: 'https://drive.google.com/drive/folders/1ROic8q5MDePkv-LHnhH9XqIteUtLhGPD?usp=sharing'
  },
  agentUrl: 'https://dev.agent.cycling-insights.io'
};
if (process.env.REACT_APP_ENV === 'staging' || process.env.GATSBY_APP_ENV === 'staging') {
  environment = {
    ...environment,
    frontendUrl: 'https://staging.geovelo.app',
    backendUrl: 'https://backend-staging.geovelo.fr',
    enterpriseUrl: 'https://app-staging.geovelo-entreprise.com/',
    eventsSiteUrl: 'https://challenges-staging.geovelo.app/',
    tileServer: {
      url: 'https://tileserver.geovelo.fr',
      styleDirs: {
        base: 'base-no-label-with-facilities-v2-5-vector',
        labels: 'labels-v2-vector',
        dark: 'base-dark-style-no-label-v2-5-vector',
        darkLabels: 'label-dark-style-v2-3-vector',
        facilities: 'facilities_v2-vector',
        facilitiesIDFM: 'facilities-style-idfm-vector',
        toner: 'app-toner-style-v2-3-with-geovelo-overlays-vector'
      }
    },
    osm: {
      apiUrl: 'https://api.openstreetmap.org'
    },
    lav: {
      backendUrl: 'https://api-search.preprod.loireavelo.com',
      imagesUrl: 'https://preprod.loireavelo.com',
      apiKey: 'Bearer 79d5040298cbea960280a02755f72cfe836f885a0583d431135f67fb95942f23'
    },
    enableSimplifyCrossingInstructions: false,
    wahoo: {
      clientId: ''
    },
    agentUrl: 'https://dev.agent.cycling-insights.io'
  };
}
if (process.env.REACT_APP_ENV === 'production' || process.env.GATSBY_APP_ENV === 'production') {
  environment = {
    ...environment,
    frontendUrl: 'https://geovelo.app',
    backendUrl: 'https://backend.geovelo.fr',
    enterpriseUrl: 'https://app.geovelo-entreprise.com/',
    eventsSiteUrl: 'https://challenges.geovelo.app/',
    tileServer: {
      url: 'https://tileserver.geovelo.fr',
      styleDirs: {
        base: 'base-no-label-with-facilities-v2-5-vector',
        labels: 'labels-v2-vector',
        dark: 'base-dark-style-no-label-v2-5-vector',
        darkLabels: 'label-dark-style-v2-3-vector',
        facilities: 'facilities_v2-vector',
        facilitiesIDFM: 'facilities-style-idfm-vector',
        toner: 'app-toner-style-v2-3-with-geovelo-overlays-vector'
      }
    },
    lav: {
      backendUrl: 'https://api-search.loireavelo.fr',
      imagesUrl: 'https://loireavelo.fr',
      apiKey: 'Bearer 79d5040298cbea960280a02755f72cfe836f885a0583d431135f67fb95942f23'
    },
    osm: {
      apiUrl: 'https://api.openstreetmap.org'
    },
    bikeAllowanceUrl: 'https://indemnitevelo.fr',
    widgetDefaultApiKey: '2190d7c6-3ef4-4bb7-ab76-779659185519',
    enableSimplifyCrossingInstructions: false,
    strava: {
      clientId: '174786'
    },
    wahoo: {
      clientId: 'JW6y_HNCuYk73Q2B3x_XAyD03BDObglIlEejxzC__PQ'
    },
    agentUrl: 'https://agent.cycling-insights.io'
  };
}
if (process.env.REACT_APP_ENV === 'local') {
  environment = {
    ...environment,
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080'
  };
}
export const defaultEnvironment = environment;